export const CANONICAL_ORIGIN = 'https://neatschedule.com';

const PRODUCTION_HOSTS = new Set(['neatschedule.com', 'www.neatschedule.com']);

export function getSiteOrigin() {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname?.toLowerCase();
    if (PRODUCTION_HOSTS.has(host)) {
      return CANONICAL_ORIGIN;
    }
    return window.location.origin;
  }
  return CANONICAL_ORIGIN;
}

export const siteSeo = {
  siteName: 'Neat Schedule',
  defaultTitle: 'Neat Schedule — Smart Scheduling for Growing Businesses',
  defaultDescription:
    'Streamline appointments, manage staff, and delight customers with Neat Schedule’s all‑in‑one scheduling platform.',
  defaultImage: '/neatschedule.png',
  twitterHandle: '@neatschedule', // update if you have a real handle
  // Default keywords applied site-wide unless a page overrides or extends
  defaultKeywords: [
    'appointment scheduling software',
    'online booking system',
    'staff scheduling',
    'client management',
    'appointment reminders',
    'scheduling',
    'booking',
    'booking software',
    'scheduling software',
    'customer management',
    'mobile service',
  ],
};
export function buildAbsoluteUrl(pathname) {
  try {
    const origin = getSiteOrigin();
    const u = new URL(pathname || '/', origin);
    return u.toString();
  } catch {
    return pathname || '/';
  }
}


